import { ReactElement, useEffect, useState } from 'react';
import { OpenIndexArrayType } from 'b2b-components/theme/components/Accordion';
import {
  getActiveSectionKeyArray,
  getNonEmptyFilters,
  getSortedFacetFilters,
  mapNumbersToSectionFields,
  mapSectionFieldsToNumbers,
} from 'b2b-apps/core/catalog/utils/facets';
import {
  Facets,
} from './Facets';
import {
  InjectedProps,
  Props,
} from './FacetsContainer.types';

export const FacetsContainer = (props: Props): ReactElement => {
  const { filters } = props;
  const sortedFilters = getSortedFacetFilters(filters);
  const [areInitialFiltersLoaded, setAreInitialFiltersLoaded] = useState(false);
  const [activeSectionKeyArray, setActiveSectionKeyArray] = useState(getActiveSectionKeyArray(filters));

  const handleActiveSectionIndexArrayChange = (openIndexArray: OpenIndexArrayType): void => {
    setActiveSectionKeyArray(mapNumbersToSectionFields(openIndexArray, sortedFilters));
  };
  const activeSectionIndexArray = mapSectionFieldsToNumbers(activeSectionKeyArray, sortedFilters);
  const nonEmptyFilters = getNonEmptyFilters(sortedFilters);

  useEffect((): void => {
    if (!areInitialFiltersLoaded && filters.length > 0) {
      setAreInitialFiltersLoaded(true);
      setActiveSectionKeyArray(getActiveSectionKeyArray(filters));
    }
  }, [areInitialFiltersLoaded, filters]);

  const injectedProps: InjectedProps = {
    activeSectionIndexArray,
    nonEmptyFilters,
    onActiveSectionIndexArrayChange: handleActiveSectionIndexArrayChange,
  };

  return <Facets {...props} {...injectedProps} />;
};
